import React, { useState } from "react";
import { ChevronDown, Quote } from "lucide-react";

const colorFor = (rank) =>
  rank === 0 ? "bg-[#002FA7] text-white border-[#002FA7]" : "bg-zinc-100 text-zinc-900 border-zinc-200";

export default function RankedList({ items, type }) {
  const [open, setOpen] = useState(null);

  if (!items || items.length === 0) {
    return (
      <div className="p-10 text-center text-zinc-400 font-mono text-sm" data-testid={`ranked-empty-${type}`}>
        No recurring themes detected in this bucket.
      </div>
    );
  }
  return (
    <div className="border border-zinc-200" data-testid={`ranked-list-${type}`}>
      {items.map((it, i) => {
        const quotes = it.quotes || [];
        const isOpen = open === i;
        const hasQuotes = quotes.length > 0;
        return (
          <div key={i} className="border-b border-zinc-200 last:border-b-0 fade-up" style={{ animationDelay: `${i * 30}ms` }}>
            <button
              onClick={() => hasQuotes && setOpen(isOpen ? null : i)}
              className={`w-full text-left flex items-center gap-4 p-4 transition-colors ${hasQuotes ? "hover:bg-zinc-50 cursor-pointer" : "cursor-default"}`}
              data-testid={`ranked-item-${type}-${i}`}
            >
              <div className={`rounded-full flex flex-col items-center justify-center font-mono font-bold h-12 w-12 flex-shrink-0 border leading-none ${colorFor(i)}`} title={`${it.mentions ?? 0} mentions`}>
                <span className="text-sm">{it.percentage ?? 0}</span>
                <span className="text-[8px] opacity-70 -mt-0.5">%</span>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-baseline gap-2">
                  <span className="font-mono text-[10px] text-zinc-400 w-5">#{i + 1}</span>
                  <h4 className="font-semibold text-zinc-900 text-[15px] leading-tight">{it.theme}</h4>
                </div>
                <p className="text-sm text-zinc-500 mt-1 ml-7">{it.summary}</p>
              </div>
              <div className="hidden sm:flex flex-col items-end flex-shrink-0">
                <div className="font-mono text-xs text-zinc-400">{it.mentions ?? 0}</div>
                <div className="text-[10px] uppercase tracking-widest text-zinc-300">mentions</div>
              </div>
              {hasQuotes && (
                <ChevronDown className={`h-4 w-4 text-zinc-400 flex-shrink-0 transition-transform ${isOpen ? "rotate-180" : ""}`} />
              )}
            </button>
            {isOpen && hasQuotes && (
              <div className="bg-zinc-50 border-t border-zinc-200 px-4 sm:px-16 py-4 space-y-3" data-testid={`quotes-${type}-${i}`}>
                <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-zinc-400">Real reviews</div>
                {quotes.map((q, qi) => (
                  <div key={qi} className="flex gap-2 text-sm text-zinc-700">
                    <Quote className="h-3.5 w-3.5 text-[#002FA7] flex-shrink-0 mt-1" />
                    <span className="italic">&ldquo;{q}&rdquo;</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
